import React, { useContext, useState } from "react";
import {
  Container,
  ContainerHeader,
  IconsArea,
  NameArea,
  StudentName,
} from "./styles";
import { ReactComponent as AddIcon } from "../../assets/add_icon.svg";
import { ReactComponent as EditIcon } from "../../assets/edit_icon.svg";
import { ReactComponent as OkIcon } from "../../assets/ok_icon.svg";
import { ReactComponent as WaitIcon } from "../../assets/wait_icon.svg";
import { ActionButton } from "../../styles/GlobalStyles";
import BoxViewer from "../BoxViewer";
import { IntegranteTabsContext } from "../IntegranteTabs/IntegranteTabs";

export const IntegranteItem = ({
  student,
  status,
  date,
  editData,
  upadateList,
  setUpdateList,
}) => {
  const { openStudentTab } = useContext(IntegranteTabsContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [listViewers, setListViewers] = useState("");
  
  // Garantir que viewers seja sempre um array
  const normalizeViewers = (viewers) => {
    if (!viewers) return [];
    if (typeof viewers === 'string') {
      try {
        const parsed = JSON.parse(viewers);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return Array.isArray(viewers) ? viewers : [];
  };
  
  const viewersArray = editData ? normalizeViewers(editData.viewers) : [];
  const viewed = status && viewersArray.length > 0;

  const handleClickViewers = (event) => {
    if (!viewersArray || viewersArray.length === 0) return;
    
    // Mostrar nome do responsável e parentesco (apenas o tipo, sem repetir o nome)
    const listOfViewers = viewersArray
      .map((item) => {
        const nome = item.nome || item.name || 'Nome não informado';
        const parentesco = item.parentesco || item.relationship || '';
        
        if (!parentesco) {
          return nome;
        }
        
        // Extrair apenas o tipo do parentesco (último conteúdo entre parênteses)
        // Exemplo: "Eveline Angelica... - (Mãe)" -> "Mãe"
        const match = parentesco.match(/\(([^)]+)\)$/);
        const tipoParentesco = match ? match[1].trim() : parentesco;
        
        return `${nome} (${tipoParentesco})`;
      })
      .join(" - ");
    setListViewers(listOfViewers);
    setAnchorEl(event.currentTarget);
  };

  const handleOpenTab = () => {
    const onSave = () => {
      setUpdateList(!upadateList);
    };
    openStudentTab(student, status, date, editData || null, onSave);
  };

  return (
    <Container>
      <ContainerHeader>
        <NameArea>
          <StudentName>{student.NumeroChamada + "- " + student.Nome}</StudentName>
        </NameArea>
        <IconsArea>
          {!status ? (
            <ActionButton onClick={handleOpenTab}>
              <AddIcon width={25} height={25} />
            </ActionButton>
          ) : (
            <ActionButton onClick={handleOpenTab}>
              <EditIcon width={30} height={30} />
            </ActionButton>
          )}
          {status && viewed ? (
            <ActionButton>
              <OkIcon width={30} height={30} onClick={handleClickViewers} />
            </ActionButton>
          ) : (
            <ActionButton>
              <WaitIcon width={25} height={25} />
            </ActionButton>
          )}
        </IconsArea>
      </ContainerHeader>
      <BoxViewer
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        viewers={listViewers}
      />
    </Container>
  );
};
